import { Navigate, Route, Routes } from "react-router-dom";
import { useBodyCustomScrollbar } from "hooks/common";
import { Route as PlatformRoute } from "constants/routes";
import { AuthLayout } from "layouts/AuthLayout";
import { AppLayout } from "layouts/AppLayout";
import { Schedule } from "pages/Schedule";
import { Login } from "pages/Login";
import { Materials } from "pages/Materials";
import { CourseDetails } from "pages/Materials/pages/course-details";
import { LessonDetails } from "pages/Materials/pages/course-details/pages/lesson-details";
import { Finance } from "pages/Finance";
import { Progress } from "pages/Progress";
import { Study } from "pages/Study";
import { Teachers } from "pages/Study/pages/teachers";
import { TeachersArchive } from "pages/Study/pages/teachers/pages/archive";
import { Students } from "pages/Study/pages/students";
import { StudentsArchive } from "pages/Study/pages/students/pages/archive";
import { StudentClassroom } from "pages/Study/pages/students/pages/classroom";
import { StudentClassroomCourse } from "pages/Study/pages/students/pages/classroom/pages/course";
import { ForgetPassword } from "pages/ForgetPassword";
import { RequestResetPassword } from "pages/RequestResetPassword";
import {
  StudentClassroomCourseLesson,
  StudentClassroomCourseLessonRedirect,
} from "./pages/Study/pages/students/pages/classroom/pages/course/pages/lesson";
import { Groups } from "pages/Study/pages/groups";
import { GroupDetails } from "pages/Study/pages/groups/pages/group-details";
import { GroupClassroom } from "pages/Study/pages/groups/pages/group-classroom";
import { GroupClassroomCourse } from "pages/Study/pages/groups/pages/group-classroom/pages/course";
import { GroupClassroomCourseLesson } from "pages/Study/pages/groups/pages/group-classroom/pages/course/pages/lesson";
import { Requests } from "pages/Study/pages/requests";
import { Reports } from "pages/Study/pages/reports";
import { UserSettings } from "pages/User/Settings";
import { AdminPage } from "pages/Admin";
import { LandingDashboard } from "pages/Admin/pages/landing";
import { AdvertisementsDashboard } from "pages/Admin/pages/advertisements";
import { AdminProtected } from "components/Layout/AdminProtected";

export const App: React.FC = () => {
  useBodyCustomScrollbar();

  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path={PlatformRoute.Auth.Login.ROOT.path} element={<Login />} />
        <Route
          path={PlatformRoute.Auth.ForgetPassword.ROOT.path}
          element={<ForgetPassword />}
        />
        <Route
          path={PlatformRoute.Auth.RequestResetPassword.ROOT.path}
          element={<RequestResetPassword />}
        />
      </Route>
      <Route element={<AppLayout />}>
        <Route
          path="*"
          element={
            <Navigate to={PlatformRoute.App.Schedule.ROOT.path} replace />
          }
        />

        <Route
          path={PlatformRoute.App.Schedule.ROOT.path}
          element={<Schedule />}
        />
        <Route path={PlatformRoute.App.Study.ROOT.path} element={<Study />} />

        <Route
          path={PlatformRoute.App.Study.STUDENTS.path}
          element={<Students />}
        />
        <Route element={<AdminProtected />}>
          <Route
            path={PlatformRoute.App.Study.STUDENTS_ARCHIVE.path}
            element={<StudentsArchive />}
          />
        </Route>
        <Route
          path={PlatformRoute.App.Study.STUDENT_CLASSROOM.path}
          element={<StudentClassroom />}
        />
        <Route
          path={PlatformRoute.App.Study.STUDENT_CLASSROOM_COURSE.path}
          element={<StudentClassroomCourse />}
        />
        <Route
          path={PlatformRoute.App.Study.STUDENT_CLASSROOM_COURSE_LESSON.path}
          element={<StudentClassroomCourseLesson />}
        />
        <Route
          path={
            PlatformRoute.App.Study.STUDENT_CLASSROOM_COURSE_LESSON_REDIRECT
              .path
          }
          element={<StudentClassroomCourseLessonRedirect />}
        />
        <Route
          path={PlatformRoute.App.Study.TEACHERS.path}
          element={<Teachers />}
        />
        <Route element={<AdminProtected />}>
          <Route
            path={PlatformRoute.App.Study.TEACHERS_ARCHIVE.path}
            element={<TeachersArchive />}
          />
        </Route>
        <Route
          path={PlatformRoute.App.Study.GROUPS.path}
          element={<Groups />}
        />
        <Route
          path={PlatformRoute.App.Study.GROUP_DETAILS.path}
          element={<GroupDetails />}
        />
        <Route
          path={PlatformRoute.App.Study.GROUP_CLASSROOM.path}
          element={<GroupClassroom />}
        />
        <Route
          path={PlatformRoute.App.Study.GROUP_CLASSROOM_COURSE.path}
          element={<GroupClassroomCourse />}
        />
        <Route
          path={PlatformRoute.App.Study.GROUP_CLASSROOM_COURSE_LESSON.path}
          element={<GroupClassroomCourseLesson />}
        />
        <Route element={<AdminProtected />}>
          <Route
            path={PlatformRoute.App.Study.REQUESTS.path}
            element={<Requests />}
          />
        </Route>
        <Route
          path={PlatformRoute.App.Study.REPORTS.path}
          element={<Reports />}
        />

        <Route
          path={PlatformRoute.App.Materials.ROOT.path}
          element={<Materials />}
        />
        <Route
          path={PlatformRoute.App.Materials.COURSE_DETAILS.path}
          element={<CourseDetails />}
        />
        <Route
          path={PlatformRoute.App.Finance.ROOT.path}
          element={<Finance />}
        />
        <Route
          path={PlatformRoute.App.Progress.ROOT.path}
          element={<Progress />}
        />
        <Route
          path={PlatformRoute.App.User.SETTINGS.path}
          element={<UserSettings />}
        />
        <Route element={<AdminProtected />}>
          <Route
            path={PlatformRoute.App.Admin.ROOT.path}
            element={<AdminPage />}
          />
          <Route
            path={PlatformRoute.App.Admin.LANDING.path}
            element={<LandingDashboard />}
          />
          <Route
            path={PlatformRoute.App.Admin.ADVERTISEMENTS.path}
            element={<AdvertisementsDashboard />}
          />
        </Route>
      </Route>
      <Route element={<AppLayout />}>
        <Route
          path={PlatformRoute.App.Materials.LESSON_DETAILS.path}
          element={<LessonDetails />}
        />
      </Route>
    </Routes>
  );
};
